module.exports = __webpack_public_path__ + "img/payroll08.0283c5eb.jpeg";